import { useQuery } from "@tanstack/react-query"

import MetricCard from "@/components/MetricCard"

import { getLiveForHireMetrics } from "../api/getLiveForHireMetrics"

export default function ForHireLiveMetrics() {
  const { data, isPending, isError } = useQuery({
    queryKey: ["liveForHireMetrics", { period: "Daily" }],
    queryFn: () => getLiveForHireMetrics("Daily"),
    refetchInterval: 5000,
  })

  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <MetricCard
        isError={isError}
        isPending={isPending}
        value={data?.activeTrucks}
        name={"Active Trucks"}
        sub={"trucks in-transit right now"}
      />
      <MetricCard
        isError={isError}
        isPending={isPending}
        value={data?.dailyRevenue}
        currency={true}
        name={"Daily Revenue"}
        sub={"total revenue today"}
      />
      <MetricCard
        isError={isError}
        isPending={isPending}
        value={data?.tripsCompleted}
        name={"Trips Completed"}
        sub={"total trips completed today"}
      />
    </div>
  )
}
